import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueParticles from "vue-particles";
import CoolLightBox from 'vue-cool-lightbox';
import VueScrollactive from 'vue-scrollactive';
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import './assets/scss/main.scss'
import './assets/scss/overrides.scss'

Vue.config.productionTip = false;
Vue.use(VueParticles);
Vue.use(CoolLightBox);
Vue.use(VueScrollactive);

// v-reveal：元素进入视口时加 is-visible，用于滚动入场动效（CSS 见 overrides.scss）
// 用法：v-reveal 或 v-reveal="120"（延迟毫秒数）
const revealObserver = typeof IntersectionObserver !== 'undefined'
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                revealObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    : null;
Vue.directive('reveal', {
    bind(el, binding) {
        el.classList.add('reveal');
        if (binding.value) el.style.transitionDelay = `${binding.value}ms`;
    },
    inserted(el) {
        if (revealObserver) revealObserver.observe(el);
        else el.classList.add('is-visible');
    },
    unbind(el) {
        if (revealObserver) revealObserver.unobserve(el);
    },
});


new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')